import { DateTime } from 'luxon';
import { UserInfo, Zone } from '../auth/models/user';

export function checkTrialAccountExpirationDate(user: UserInfo) {
  const expirationDate =
    user?.expirationDate === null
      ? DateTime.now().toUTC().setZone(Zone[user?.region])
      : DateTime.fromISO(user?.expirationDate).toUTC();
  let hours = '';
  const expireDate = DateTime.fromISO(user?.expirationDate).toUTC();
  if (expireDate.diff(DateTime.now().toUTC(), 'days').toObject().days > 1) {
    return `${Math.round(
      expireDate.diff(DateTime.now().toUTC(), 'days').toObject().days
    )} days `;
  }

  const minutes = expireDate
    .diff(DateTime.now().toUTC(), 'minutes')
    .toObject()
    .minutes.toString()
    .replace('-', '');
  const seconds = expireDate
    .diff(DateTime.now().toUTC(), 'seconds')
    .toObject()
    .seconds.toString()
    .replace('-', '');

  if (parseInt(minutes) > 45) {
    hours = `${Math.round(
      expireDate.diff(DateTime.now().toUTC(), 'hours').toObject().hours
    )} hours `;
    if (Math.sign(parseInt(hours)) === -1) {
      return `${hours.replace('-', '')} ago`;
    }
    return `${hours}`;
  }
  if (parseInt(seconds) < 60) {
    if (
      Math.sign(
        expireDate.diff(DateTime.now().toUTC(), 'minutes').toObject().minutes
      ) === -1
    ) {
      return 'few seconds ago';
    }
    return 'few seconds';
  }
  return DateTime.fromISO(user?.expirationDate).toRelative();
}
export function checkTrialDateExpire(user: UserInfo) {
  const expireDate = DateTime.fromISO(user.expirationDate?.toString())
    .setZone(Zone[user?.region])
    .endOf('day');
  return expireDate
    .diff(DateTime.utc().setZone(Zone[user?.region]).startOf('day'), 'days')
    .toObject().days < 0
    ? true
    : false;
}
